export function extractUrlParams(initialUrl) {
  let params = {};
  if (initialUrl) {
    let urlParts = initialUrl.split("?");
    if (urlParts && urlParts.length > 1) {
      let parameters = urlParts[1];
      let paramsParts = parameters.split("&");
      if (paramsParts) {
        paramsParts.forEach((parameter) => {
          let paramsKeyValue = parameter.split("=");
          params[paramsKeyValue[0]] = paramsKeyValue[1];
        });
      }
    }
  }
 // localStorage.setItem("username", params.username);
  localStorage.setItem("token", params.token);

  return params;
}

export function convertHex(hexCode, opacity) {
  let hex = hexCode.replace("#", "");
  if (hex.length === 3) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }
  let r = parseInt(hex.substring(0, 2), 16),
    g = parseInt(hex.substring(2, 4), 16),
    b = parseInt(hex.substring(4, 6), 16);
  return "rgba(" + r + "," + g + "," + b + "," + opacity / 100 + ")";
}
